import type { RouteRecordRaw } from "vue-router";

import { APP_CHAT_CUSTOMER_SCHEDULE_ROUTES as SCHEDULE } from "@/Generated/Routes/paths";

import { buildBeforeEnterChain, chatCustomerGuard } from "@/Router/guards";

const CustomerRoutes: RouteRecordRaw[] = [
  {
    ...SCHEDULE.root,
    component: () => import("@/Views/chat/customer/views/Schedule/index.vue"),
    meta: {
      i18nTitle: "schedule.professional.customer.title",
    },
    beforeEnter: buildBeforeEnterChain([chatCustomerGuard]),
  },
];

export default CustomerRoutes;
